'use strict';

var intersectionWith = require('lodash/intersectionWith');

module.exports = function (alpha, beta) {
    return intersectionWith(alpha, beta, function (a, b) {
        return a.category === b.category && a.keyword === b.keyword;
    });
};



// WEBPACK FOOTER //
// ./util/intersectFacets.js